module.exports = __webpack_public_path__ + "static/img/Full-Body3.404ede67.jpg";